import { render, staticRenderFns } from "./questionBoard.vue?vue&type=template&id=162dabca&scoped=true"
import script from "./questionBoard.vue?vue&type=script&lang=js"
export * from "./questionBoard.vue?vue&type=script&lang=js"
import style0 from "./questionBoard.vue?vue&type=style&index=0&id=162dabca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162dabca",
  null
  
)

export default component.exports